export default {
  OPEN: 'Open',
  ORDER_VERIFICATION: 'Verification',
  ORDER_VERIFIED: 'Verified',
  ADDED_TO_SHIPMENT: 'Shipment Created',
  HOLD: 'Hold',
  CANCELED: 'Canceled',
  READY_FOR_SHIPMENT: 'Ready for shipment',
  SHIPPED: 'Shipped',
  ORDER_RE_VERIFICATION: 'Reverification',
  EXPIRED: 'Expired',
  TRANSFERRED: 'Transferred',
  // POM-6180 / POM-6211: parked by a whole-order Fill Later move; released on its fill date.
  // POM-TBD: reported as VOID until this release, which read as cancelled everywhere outside
  // the Fill Later work.
  FILL_LATER: 'Fill Later',
};
